require("../scss/errorpage.scss");

require("./localize-html.js");
require("../js/reloader.js");
